module.exports = __webpack_public_path__ + "img/facebook-green-thin.69938360.svg";